import { supabaseAdmin } from '../supabase.js';

class SubjectService {
  constructor(tenantId = 'eadcd263-a399-4261-8cbd-8fb1ce6da0e3') {
    this.tenantId = tenantId;
  }

  // Fetch all subject teacher assignments
  async getSubjectTeacherAssignments() {
    try {
      const { data, error } = await supabaseAdmin
        .from('teacher_assignments')
        .select(`
          subject_name,
          member_role,
          saas_teachers!teacher_assignments_teacher_id_fkey(
            id,
            name,
            teacher_id,
            subject_specialty
          )
        `)
        .eq('tenant_id', this.tenantId)
        .eq('assignment_type', 'subject_teacher')
        .order('subject_name');

      if (error) {
        console.error('Error fetching subject teacher assignments:', error);
        return { subjects: [], error };
      }

      // Organize data by subjects
      const subjects = this.organizeSubjectsWithTeachers(data || []);
      return { subjects, error: null };
    } catch (error) {
      console.error('Error in getSubjectTeacherAssignments:', error);
      return { subjects: [], error };
    }
  }

  // Organize teachers by subjects
  organizeSubjectsWithTeachers(assignments) {
    const subjectMap = new Map();

    assignments.forEach(assignment => {
      if (assignment.saas_teachers && assignment.subject_name) {
        const subjectName = assignment.subject_name;
        
        if (!subjectMap.has(subjectName)) {
          subjectMap.set(subjectName, {
            name: subjectName,
            teachers: []
          });
        }
        
        // Add teacher with role information
        const teacherWithRole = {
          ...assignment.saas_teachers,
          role: assignment.member_role || ''
        };
        
        // Check if teacher already exists and update role if needed
        const existingTeacherIndex = subjectMap.get(subjectName).teachers.findIndex(
          t => t.id === assignment.saas_teachers.id
        );
        
        if (existingTeacherIndex >= 0) {
          // Update existing teacher's role
          subjectMap.get(subjectName).teachers[existingTeacherIndex].role = assignment.member_role || '';
        } else {
          // Add new teacher
          subjectMap.get(subjectName).teachers.push(teacherWithRole);
        }
      }
    });

    // Convert to array and sort by subject name
    return Array.from(subjectMap.values()).sort((a, b) => a.name.localeCompare(b.name, 'zh-CN'));
  }

  // Get teachers for a specific subject
  async getTeachersBySubject(subjectName) {
    try {
      const { data, error } = await supabaseAdmin
        .from('teacher_assignments')
        .select(`
          saas_teachers!teacher_assignments_teacher_id_fkey(
            id,
            name,
            teacher_id,
            subject_specialty
          )
        `)
        .eq('tenant_id', this.tenantId)
        .eq('assignment_type', 'subject_teacher')
        .eq('subject_name', subjectName);

      if (error) {
        console.error('Error fetching teachers by subject:', error);
        return { teachers: [], error };
      }

      const teachers = (data || []).map(item => item.saas_teachers);
      return { teachers, error: null };
    } catch (error) {
      console.error('Error in getTeachersBySubject:', error);
      return { teachers: [], error };
    }
  }
}

export default SubjectService;
